import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import Navigation from '../../components/feature/Navigation';
import Footer from '../../components/feature/Footer';

export default function ContactPage() {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  // Set page title and meta tags
  useEffect(() => {
    document.title = '미래인재학원 입학상담';
    
    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.setAttribute('content', '📞 입학상담 신청! 지행 010-5647-1320, 옥정 010-5606-1320, 민락 010-5492-1320');
    }
    
    const ogTitle = document.querySelector('meta[property="og:title"]');
    if (ogTitle) {
      ogTitle.setAttribute('content', '미래인재학원 입학상담');
    }
    
    const ogDescription = document.querySelector('meta[property="og:description"]');
    if (ogDescription) {
      ogDescription.setAttribute('content', '📞 입학상담 신청! 지행 010-5647-1320, 옥정 010-5606-1320, 민락 010-5492-1320');
    }

    // FAQPage Schema
    const existingFaqSchema = document.getElementById('schema-faq');
    if (!existingFaqSchema) {
      const script = document.createElement('script');
      script.id = 'schema-faq';
      script.type = 'application/ld+json';
      script.textContent = JSON.stringify({
        "@context": "https://schema.org",
        "@type": "FAQPage",
        "mainEntity": [
          {
            "@type": "Question",
            "name": "미래인재학원 수업료는 얼마인가요?",
            "acceptedAnswer": {
              "@type": "Answer",
              "text": "수업료는 과목, 학년, 수업 횟수에 따라 다릅니다. 정확한 수업료는 각 캠퍼스로 전화 상담을 통해 안내받으실 수 있습니다. 지행캠퍼스 010-5647-1320, 옥정캠퍼스 010-5606-1320, 민락캠퍼스 010-5492-1320으로 연락해 주세요."
            }
          },
          {
            "@type": "Question",
            "name": "미래인재학원은 어떤 과목을 가르치나요?",
            "acceptedAnswer": {
              "@type": "Answer",
              "text": "미래인재학원은 수학, 영어, 국어, 과학 4개 과목을 전문적으로 가르칩니다. 중등과정과 고등과정 모두 운영하며, 내신 대비와 수능 대비를 동시에 진행합니다."
            }
          },
          {
            "@type": "Question",
            "name": "한 반에 몇 명이 수업하나요?",
            "acceptedAnswer": {
              "@type": "Answer",
              "text": "미래인재학원은 소수정예 원칙을 철저히 지킵니다. 중등 수학은 한 반 8명 이내, 고등 수학은 10명 이내로 운영합니다. 특히 B·C반은 8명 이하로 엄격하게 제한하여 밀착 케어를 보장합니다."
            }
          },
          {
            "@type": "Question",
            "name": "미래인재학원 캠퍼스는 어디에 있나요?",
            "acceptedAnswer": {
              "@type": "Answer",
              "text": "미래인재학원은 3개 캠퍼스를 운영합니다. 지행캠퍼스(경기도 동두천시 지행로 50, 성지에스엔비타워 4,5,6층), 옥정캠퍼스(경기도 양주시 회천남로 92, 센타프라자 7,8,9층), 민락캠퍼스(경기도 의정부시 오목로 221, 골드노블레스프라자 2,3,4층)에 위치해 있습니다."
            }
          },
          {
            "@type": "Question",
            "name": "결석 시 보강은 어떻게 하나요?",
            "acceptedAnswer": {
              "@type": "Answer",
              "text": "모든 수업은 실시간으로 녹화됩니다. 결석 시 학원에 등원하여 조교 선생님의 지도하에 영상 보강 수업을 진행합니다. 집에서 혼자 듣는 것이 아닌, 학원에서 관리받으며 보강합니다."
            }
          },
          {
            "@type": "Question",
            "name": "레벨 테스트는 어떻게 진행되나요?",
            "acceptedAnswer": {
              "@type": "Answer",
              "text": "입학 전 정확한 레벨 테스트를 통해 학생의 현재 실력을 진단합니다. 테스트 결과에 따라 S, A, B, C반으로 배정되며, 정기적인 월간고사를 통해 레벨을 재평가하여 상위 반 승급 기회를 제공합니다."
            }
          },
          {
            "@type": "Question",
            "name": "장학 혜택이 있나요?",
            "acceptedAnswer": {
              "@type": "Answer",
              "text": "네, 미래인재학원은 다양한 장학 혜택을 제공합니다. 수능 1등급 달성 시 3학년 2학기 수강료의 50%를 환급해 드리며, 성적 우수 장학생 제도를 운영하고 있습니다. 자세한 내용은 장학생 명단 및 장학혜택 페이지에서 확인하실 수 있습니다."
            }
          }
        ]
      });
      document.head.appendChild(script);
    }

    // ContactPage Schema
    const existingContactSchema = document.getElementById('schema-contact');
    if (!existingContactSchema) {
      const contactScript = document.createElement('script');
      contactScript.id = 'schema-contact';
      contactScript.type = 'application/ld+json';
      contactScript.textContent = JSON.stringify({
        "@context": "https://schema.org",
        "@type": "ContactPage",
        "name": "미래인재학원 상담 문의",
        "description": "미래인재학원 입학 상담 및 등록 문의 페이지. 지행, 옥정, 민락 캠퍼스 연락처 안내.",
        "url": "https://eliteoffuture1.com/contact",
        "mainEntity": {
          "@type": "EducationalOrganization",
          "name": "미래인재학원",
          "contactPoint": [
            {
              "@type": "ContactPoint",
              "telephone": "010-5647-1320",
              "contactType": "customer service",
              "areaServed": "동두천시",
              "availableLanguage": "Korean"
            },
            {
              "@type": "ContactPoint",
              "telephone": "010-5606-1320",
              "contactType": "customer service",
              "areaServed": "양주시",
              "availableLanguage": "Korean"
            },
            {
              "@type": "ContactPoint",
              "telephone": "010-5492-1320",
              "contactType": "customer service",
              "areaServed": "의정부시",
              "availableLanguage": "Korean"
            }
          ]
        }
      });
      document.head.appendChild(contactScript);
    }

    return () => {
      const faqEl = document.getElementById('schema-faq');
      if (faqEl) faqEl.remove();
      const contactEl = document.getElementById('schema-contact');
      if (contactEl) contactEl.remove();
    };
  }, []);

  return (
    <div className="min-h-screen bg-black">
      <Navigation currentPage="contact" />

      {/* Hero Section */}
      <section className="pt-20 relative min-h-[500px] flex items-center">
        <div className="absolute inset-0 bg-black">
          <img 
            src="https://public.readdy.ai/ai/img_res/57809519cd5be1006b0b14b5773c1f3a.jpg"
            alt="Contact Hero"
            className="w-full h-full object-cover object-top opacity-25"
          />
          <div className="absolute inset-0 bg-gradient-to-r from-black via-black/85 to-black/60"></div>
        </div>
        <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-20 w-full">
          <div className="max-w-2xl">
            <div className="inline-block px-4 py-2 bg-yellow-400/10 border border-yellow-400/30 rounded-full mb-6">
              <span className="text-yellow-400 text-sm font-medium">상담 신청</span>
            </div>
            <h1 className="text-5xl md:text-6xl font-bold text-white mb-6 leading-tight">
              미래인재학원 입학상담
            </h1>
            <p className="text-lg md:text-xl text-neutral-400 leading-relaxed">
              학원 상담이 필요하신가요?<br />
              각 캠퍼스로 연락주시면 빠르게 상담해드리겠습니다
            </p>
          </div>
        </div>
      </section>

      {/* Campus Contact Info Section */}
      <section className="py-20 px-4 relative overflow-hidden" style={{background: 'linear-gradient(135deg, #0a0a0a 0%, #111111 40%, #0d0d0d 100%)'}}>
        {/* 배경 장식 요소 */}
        <div className="absolute inset-0 pointer-events-none">
          <div className="absolute top-0 left-0 w-full h-px bg-gradient-to-r from-transparent via-yellow-400/30 to-transparent"></div>
          <div className="absolute bottom-0 left-0 w-full h-px bg-gradient-to-r from-transparent via-yellow-400/20 to-transparent"></div>
          <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[800px] rounded-full bg-yellow-400/3 blur-3xl"></div>
          <div className="absolute top-10 left-10 w-64 h-64 rounded-full bg-yellow-400/5 blur-2xl"></div>
          <div className="absolute bottom-10 right-10 w-64 h-64 rounded-full bg-yellow-400/5 blur-2xl"></div>
          {/* 격자 패턴 */}
          <div className="absolute inset-0 opacity-5" style={{backgroundImage: 'linear-gradient(rgba(250,204,21,0.3) 1px, transparent 1px), linear-gradient(90deg, rgba(250,204,21,0.3) 1px, transparent 1px)', backgroundSize: '60px 60px'}}></div>
        </div>

        <div className="max-w-6xl mx-auto relative z-10">
          <div className="mb-14 text-center">
            <div className="inline-flex items-center gap-2 px-4 py-1.5 bg-yellow-400/10 border border-yellow-400/30 rounded-full mb-5">
              <i className="ri-phone-line text-yellow-400 text-sm"></i>
              <span className="text-yellow-400 text-sm font-medium">직접 연락하기</span>
            </div>
            <h3 className="text-3xl font-bold text-white mb-4">캠퍼스 연락처</h3>
            <p className="text-neutral-500 text-lg">
              각 캠퍼스로 직접 연락하실 수 있습니다
            </p>
          </div>

          <div className="grid md:grid-cols-3 gap-8">
            {/* 지행캠퍼스 */}
            <div className="group relative rounded-2xl overflow-hidden transition-all duration-300 hover:-translate-y-1">
              {/* 카드 외곽 글로우 */}
              <div className="absolute inset-0 rounded-2xl bg-gradient-to-b from-yellow-400/20 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300 blur-sm -z-10 scale-105"></div>
              {/* 카드 본체 */}
              <div className="relative bg-neutral-900 rounded-2xl border border-neutral-700 overflow-hidden shadow-2xl shadow-black/60 group-hover:border-yellow-400/60 group-hover:shadow-yellow-400/10 transition-all duration-300">
                {/* 상단 강조 라인 */}
                <div className="h-1 w-full bg-gradient-to-r from-yellow-500 via-yellow-400 to-yellow-300"></div>
                <div className="bg-gradient-to-br from-yellow-400 to-yellow-500 p-6 text-black relative overflow-hidden">
                  <div className="absolute top-0 right-0 w-32 h-32 bg-white/20 rounded-full -translate-y-1/2 translate-x-1/2"></div>
                  <div className="absolute bottom-0 left-0 w-20 h-20 bg-black/10 rounded-full translate-y-1/2 -translate-x-1/2"></div>
                  <div className="relative z-10 flex items-center justify-between">
                    <h4 className="text-xl font-bold">지행캠퍼스</h4>
                    <div className="w-9 h-9 flex items-center justify-center bg-black/15 rounded-full">
                      <i className="ri-building-2-line text-black text-lg"></i>
                    </div>
                  </div>
                </div>
                <div className="p-6 space-y-4 bg-gradient-to-b from-neutral-900 to-neutral-950">
                  <div className="flex items-start gap-3">
                    <div className="w-8 h-8 flex items-center justify-center bg-yellow-400/10 rounded-lg flex-shrink-0 mt-0.5">
                      <i className="ri-phone-line text-yellow-400 text-sm"></i>
                    </div>
                    <div>
                      <div className="text-xs text-neutral-600 mb-0.5">대표번호</div>
                      <a href="tel:010-5647-1320" className="font-semibold text-white hover:text-yellow-400 transition-colors cursor-pointer text-base">010-5647-1320</a>
                    </div>
                  </div>
                  <div className="h-px bg-neutral-800"></div>
                  <div className="flex items-start gap-3">
                    <div className="w-8 h-8 flex items-center justify-center bg-yellow-400/10 rounded-lg flex-shrink-0 mt-0.5">
                      <i className="ri-map-pin-line text-yellow-400 text-sm"></i>
                    </div>
                    <div className="text-sm text-neutral-400 leading-relaxed">
                      경기도 동두천시 지행로 50<br />
                      성지에스엔비타워 4,5,6층
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* 옥정캠퍼스 */}
            <div className="group relative rounded-2xl overflow-hidden transition-all duration-300 hover:-translate-y-1">
              <div className="absolute inset-0 rounded-2xl bg-gradient-to-b from-yellow-400/20 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300 blur-sm -z-10 scale-105"></div>
              <div className="relative bg-neutral-900 rounded-2xl border border-neutral-700 overflow-hidden shadow-2xl shadow-black/60 group-hover:border-yellow-400/60 group-hover:shadow-yellow-400/10 transition-all duration-300">
                <div className="h-1 w-full bg-gradient-to-r from-yellow-500 via-yellow-400 to-yellow-300"></div>
                <div className="bg-gradient-to-br from-yellow-400 to-yellow-500 p-6 text-black relative overflow-hidden">
                  <div className="absolute top-0 right-0 w-32 h-32 bg-white/20 rounded-full -translate-y-1/2 translate-x-1/2"></div>
                  <div className="absolute bottom-0 left-0 w-20 h-20 bg-black/10 rounded-full translate-y-1/2 -translate-x-1/2"></div>
                  <div className="relative z-10 flex items-center justify-between">
                    <h4 className="text-xl font-bold">옥정캠퍼스</h4>
                    <div className="w-9 h-9 flex items-center justify-center bg-black/15 rounded-full">
                      <i className="ri-building-2-line text-black text-lg"></i>
                    </div>
                  </div>
                </div>
                <div className="p-6 space-y-4 bg-gradient-to-b from-neutral-900 to-neutral-950">
                  <div className="flex items-start gap-3">
                    <div className="w-8 h-8 flex items-center justify-center bg-yellow-400/10 rounded-lg flex-shrink-0 mt-0.5">
                      <i className="ri-phone-line text-yellow-400 text-sm"></i>
                    </div>
                    <div>
                      <div className="text-xs text-neutral-600 mb-0.5">대표번호</div>
                      <a href="tel:010-5606-1320" className="font-semibold text-white hover:text-yellow-400 transition-colors cursor-pointer text-base">010-5606-1320</a>
                    </div>
                  </div>
                  <div className="h-px bg-neutral-800"></div>
                  <div className="flex items-start gap-3">
                    <div className="w-8 h-8 flex items-center justify-center bg-yellow-400/10 rounded-lg flex-shrink-0 mt-0.5">
                      <i className="ri-map-pin-line text-yellow-400 text-sm"></i>
                    </div>
                    <div className="text-sm text-neutral-400 leading-relaxed">
                      경기도 양주시 회천남로 92<br />
                      센타프라자 7,8,9층
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* 민락캠퍼스 */}
            <div className="group relative rounded-2xl overflow-hidden transition-all duration-300 hover:-translate-y-1">
              <div className="absolute inset-0 rounded-2xl bg-gradient-to-b from-yellow-400/20 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300 blur-sm -z-10 scale-105"></div>
              <div className="relative bg-neutral-900 rounded-2xl border border-neutral-700 overflow-hidden shadow-2xl shadow-black/60 group-hover:border-yellow-400/60 group-hover:shadow-yellow-400/10 transition-all duration-300">
                <div className="h-1 w-full bg-gradient-to-r from-yellow-500 via-yellow-400 to-yellow-300"></div>
                <div className="bg-gradient-to-br from-yellow-400 to-yellow-500 p-6 text-black relative overflow-hidden">
                  <div className="absolute top-0 right-0 w-32 h-32 bg-white/20 rounded-full -translate-y-1/2 translate-x-1/2"></div>
                  <div className="absolute bottom-0 left-0 w-20 h-20 bg-black/10 rounded-full translate-y-1/2 -translate-x-1/2"></div>
                  <div className="relative z-10 flex items-center justify-between">
                    <h4 className="text-xl font-bold">민락캠퍼스</h4>
                    <div className="w-9 h-9 flex items-center justify-center bg-black/15 rounded-full">
                      <i className="ri-building-2-line text-black text-lg"></i>
                    </div>
                  </div>
                </div>
                <div className="p-6 space-y-4 bg-gradient-to-b from-neutral-900 to-neutral-950">
                  <div className="flex items-start gap-3">
                    <div className="w-8 h-8 flex items-center justify-center bg-yellow-400/10 rounded-lg flex-shrink-0 mt-0.5">
                      <i className="ri-phone-line text-yellow-400 text-sm"></i>
                    </div>
                    <div>
                      <div className="text-xs text-neutral-600 mb-0.5">대표번호</div>
                      <a href="tel:010-5492-1320" className="font-semibold text-white hover:text-yellow-400 transition-colors cursor-pointer text-base">010-5492-1320</a>
                    </div>
                  </div>
                  <div className="h-px bg-neutral-800"></div>
                  <div className="flex items-start gap-3">
                    <div className="w-8 h-8 flex items-center justify-center bg-yellow-400/10 rounded-lg flex-shrink-0 mt-0.5">
                      <i className="ri-map-pin-line text-yellow-400 text-sm"></i>
                    </div>
                    <div className="text-sm text-neutral-400 leading-relaxed">
                      경기도 의정부시 오목로 221<br />
                      골드노블레스프라자 2,3,4층
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Footer */}
      <Footer />
    </div>
  );
}
